import { render, staticRenderFns } from "./VChooseTemplate.vue?vue&type=template&id=641b6b3b&scoped=true"
import script from "./VChooseTemplate.vue?vue&type=script&lang=js"
export * from "./VChooseTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641b6b3b",
  null
  
)

export default component.exports